import React, { useState } from "react";
import {
  Grid,
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from "@material-ui/core/";

import ProtocolService from "../../../services/ProtocolService";
import { useStyles } from "../../../components/FormEndTitle/FormEndTitleStyle";
import SuccessIMG from "../../../assets/success.png";
import { Link } from "react-router-dom";
import Controls from "../../../components/controls/Controls";
import { AppThemeRequestProvider } from "../../../context/ThemeRequestContext";
import TmpButtonCustom from "../../../components/tempo/TmpButtonCustom/TmpButtonCustom";
import TmpInputCustom from "../../../components/tempo/TmpInputCustom/TmpInputCustom";
import TmpSkeletonLeftPageCustom from "../../../components/tempo/TmpSkeletonLeftPageCustom/TmpSkeletonLeftPageCustom";
import TmpTypographyCustom from "../../../components/tempo/TmpTypographyCustom/TmpTypographyCustom";
interface ProtocolProps {
  title: string;
}

export default function ProtocolComponent(props: ProtocolProps) {
  const [protocolState, setProtocolState] = useState("");
  const [result, setResult] = useState<any>();
  const [protocolHasChanged, setProtocolHasChanged] = useState(false);
  const classes = useStyles();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    setProtocolState(e.target.value);
    setProtocolHasChanged(true);
  };

  const sendRequest = () => {
    if (protocolHasChanged) {
      ProtocolService.getStatusProtocol(protocolState).then((e) => {
        if (e === undefined || e === null) {
        } else {
          setResult(e);
        }
      });
    }
  };

  enum Status {
    Aprovado = "Aprovado",
    Reprovado = "Não Autorizado",
    EmAnalise = "Em Análise"
  }

  return (
    <AppThemeRequestProvider>
      <Grid container>
        <Grid item xs={6}>
          <Grid container>
            <Grid item xs={12}>
              <TmpSkeletonLeftPageCustom
                title={["Consulte aqui o <br/> status da <br/>sua solicitação "]}
                showImage={false}
                subTitle={"O número de protocolo é uma identificação da sua solicitação. Com o número do seu protocolo é possível obter informações o andamento de sua solicitação. Informe abaixo o número do seu protocolo para acompanhar o status da sua solicitação."}
              />
            </Grid>
            <Grid item xs={6}>
              <TmpInputCustom id={"searchProtocol"} name={"searchProtocol"} label={"Protocolo *"} type={"text"} placeholder={"Número de protocolo"} onChange={handleChange}></TmpInputCustom>
            </Grid>
            <Grid item xs={2} style={{ "display": "flex", alignItems: "center", paddingLeft: "10px", paddingTop: "15px" }}>
              <TmpButtonCustom type={"primary"} typeButton={"button"} size={"sm"} handleClick={sendRequest}>Buscar</TmpButtonCustom>
            </Grid>

            <Grid item xs={12}>
              <br/>
              {result?.protocol ? (
                <TableContainer component={Paper}>
                  <Table size="small">
                    <TableHead style={{ backgroundColor: "#1983c6" }}>
                      <TableRow>
                        <TableCell style={{ color: "#fff" }} align="center">
                            Protocolo
                        </TableCell>
                        <TableCell style={{ color: "#fff" }} align="center">
                          Data de Atualização
                        </TableCell>
                        <TableCell style={{ color: "#fff" }} align="center">
                          Status da solicitação
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableCell align="center">
                        {result?.protocol}
                      </TableCell>
                      <TableCell align="center">
                        {result?.lastUpdateDate}
                      </TableCell>
                      <TableCell align="center">
                        <span className={result.status === Status.Aprovado ? classes.badgeSuccess : (result.status === Status.Reprovado ? classes.badgeCancel : classes.badgeWarning)}>
                          {result.status}
                        </span>
                      </TableCell>
                    </TableBody>
                  </Table>
                </TableContainer>
              ) : null}
            </Grid>
            <Grid item xs={12}>
              <br />
              <br />
              <TmpTypographyCustom component="heading" size="small" variant="h4" id="mensagem-1">
                Para mais informações, entrar em contato com o
                <strong> SAM – Serviço de Apoio ao Médico.</strong>
              </TmpTypographyCustom>
              <br />
              <TmpTypographyCustom component="heading" size="small" variant="h4" id="mensagem-2">
                SAM SP - Atendimento de segunda a sexta-feira, das
                <strong> 7h às 18h30. </strong>
                <br />
                <strong> (11) 3394-1000 sam@hsl.org.br </strong>
              </TmpTypographyCustom>
              <br />
              <TmpTypographyCustom  component="heading" size="small" variant="h4" id="mensagem-3">

                SAM BSB - Atendimento de segunda a sexta-feira, das <strong> 8h às 18h30. </strong>
                <br />
                <strong>(61) 3044-8888 (opção 6) sambrasilia@hsl.org.br</strong>
              </TmpTypographyCustom>
              <br />
              <br />
              <Grid item >
                <Link to="/" className={classes.link}>
                  <Controls.Button text="Voltar ao início" type="Success" />
                </Link>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={6}>
          <Grid item>
            <img src={SuccessIMG} className={classes.image} alt="Imagem ilustrativa da busca do protocolo" />
          </Grid>
        </Grid>
      </Grid>
    </AppThemeRequestProvider >
  );
}
